<div class="call-card" data-e2e="call-card">
  <i class="mi2-get-employee-state text-[40px] mx-2"></i>
  <div class="call-card-info">
    <div class="call-card-title" title="{{ 'cl_chat.missedCall' | translate }}">
      {{ 'cl_chat.missedCall' | translate }}
    </div>
    <div
      class="call-card-detail"
      title="{{ 'cl_chat.calledAt' | translate }} {{
        bodyObject()?.record?.createdOn | date: 'shortTime' : undefined : dateTimeLocale()
      }}"
    >
      {{ 'cl_chat.calledAt' | translate }}
      {{ bodyObject()?.record?.createdOn | date: 'shortTime' : undefined : dateTimeLocale() }}
    </div>
    <div class="call-card-detail" title="{{ bodyObject()?.record?.fromName }}">
      {{ bodyObject()?.record?.fromName }}
    </div>
  </div>
</div>
